import React, { Suspense, lazy } from "react";
import { Route, Routes, Navigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Code splitting: každá routa = vlastní chunk → menší prvotní bundle
const HomeOne = lazy(() => import("./Components/HomeOne"));
const About = lazy(() => import("./Components/About"));
const Contact = lazy(() => import("./Components/Contact"));
const TeamDetails = lazy(() => import("./Components/TeamDetails"));
const ErrorPage = lazy(() => import("./Components/Error"));
const Services = lazy(() => import("./Components/Services"));
const ServiceDetails = lazy(() => import("./Components/Services/ServiceDetails"));
const Product = lazy(() => import("./Components/Product"));
const ProductDetails = lazy(() => import("./Components/Product/ProductDetails"));
const SubProductDetails = lazy(() =>
  import("./Components/Product/ProductDetails/SubProductDetails")
);
const TeamArea = lazy(() => import("./Components/HomeOne/TeamArea"));
const Iso = lazy(() => import("./Components/ISO"));

function Loader() {
  return <div style={{ minHeight: "60vh" }} aria-busy="true" />;
}

const LanguageRoutes = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  React.useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<HomeOne />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<TeamArea />} />
        <Route path="/team-details/:teamId" element={<TeamDetails />} />
        <Route path="/products" element={<Product />} />
        <Route path="/products/:productLink" element={<ProductDetails />} />
        <Route
          path="/products/:productLink/:subProductLink"
          element={<SubProductDetails />}
        />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceLink" element={<ServiceDetails />} />
        <Route path="/iso" element={<Iso />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Suspense>
  );
};

function Routers() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/cs/" replace />} />
      <Route path="/:lang/*" element={<LanguageRoutes />} />
    </Routes>
  );
}

export default Routers;
